import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxonEvent, PublishParams } from '@reflex/shared';
import { listAxons, getAxon, getAxonEvents, publishToAxon, type AxonListItem } from './api';

export type { AxonListItem };

export const AXONS_PAGE_SIZE = 20;

export function useAxons(cursor: string | undefined) {
  return useQuery({
    queryKey: ['axons', cursor ?? null],
    queryFn: () => listAxons({ limit: AXONS_PAGE_SIZE, starting_after: cursor }),
    placeholderData: (previous) => previous,
  });
}

export function useAxon(id: string | null) {
  return useQuery({
    queryKey: ['axon', id],
    queryFn: () => getAxon(id!),
    enabled: !!id,
  });
}

export function useAxonEvents(axonId: string | null) {
  return useQuery<AxonEvent[]>({
    queryKey: ['axon-events', axonId],
    queryFn: () => getAxonEvents(axonId!),
    enabled: !!axonId,
  });
}

export function usePublishToAxon() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ axonId, params }: { axonId: string; params: PublishParams }) =>
      publishToAxon(axonId, params),
    onSuccess: (_data, vars) => qc.invalidateQueries({ queryKey: ['axon-events', vars.axonId] }),
  });
}
